import { ThunkType } from "../../../../core/store/reducers";
import { getPaymentsReport } from "../api/getPaymentsReport";
import fileDownload from "js-file-download";
import { setFetchState } from "../paymentsDataSlice";

export const downloadPaymentsReport = (): ThunkType => async (
  dispatch,
  getStore
) => {
  const store = getStore();

  if (store.data.auth.current.status !== "successful") {
    return undefined;
  }

  const { filter } = store.ux.clearing.payments;
  const user = store.data.auth.current.user;

  dispatch(setFetchState({ type: "started" }));
  const ordersReport = await dispatch(getPaymentsReport(user, filter));
  if (ordersReport) {
    fileDownload(
      new Blob([ordersReport as any], { type: "application/pdf" }),
      "Payments.pdf"
    );
  }
  dispatch(setFetchState({ type: "not-started" }));
};

